import { useEffect, useState } from "react";

/**
 * Whether something that is being hidden should still be in the DOM: true while `shown`, and for `ms` after it
 * turns false, so an exit animation (`slide-out-left`, 200ms) can play before it goes. Showing again within that
 * time keeps it mounted. The state catches up during render rather than in an effect, so showing costs no extra
 * render.
 */
export function useDelayedUnmount(shown: boolean, ms = 200): boolean {
  const [mounted, setMounted] = useState(shown);
  if (shown && !mounted) setMounted(true);
  useEffect(() => {
    if (shown) return undefined;
    const timer = setTimeout(() => setMounted(false), ms);
    return () => clearTimeout(timer);
  }, [shown, ms]);
  return shown || mounted;
}
